import { useLayoutEffect as e, useState as t } from "react";
//#region src/components/SegmentedTabs/hooks/useSegmentThumb.ts
var n = (n, r, i) => {
	let [a, o] = t(null);
	return e(() => {
		let e = n.current, t = () => {
			let e = r.current;
			e && o((t) => t && t.x === e.offsetLeft && t.width === e.offsetWidth ? t : {
				x: e.offsetLeft,
				width: e.offsetWidth
			});
		};
		if (t(), !e || typeof ResizeObserver > "u") return;
		let i = new ResizeObserver(t);
		return i.observe(e), () => i.disconnect();
	}, [
		i,
		r,
		n
	]), a;
};
//#endregion
export { n as useSegmentThumb };
